import { FACharLimit } from "../../../constants";

export default function remainingChars(currentChars: any) {
  const remainingChars = FACharLimit - currentChars;
  return remainingChars;
}
